import api from './api'

export const reporteService = {
  async getReporteUsuarios(params = {}) {
    const response = await api.get('/reportes/usuarios', { params })
    return response.data
  },

  async getReporteCitas(params = {}) {
    const response = await api.get('/reportes/citas', { params })
    return response.data
  },

  async getReporteFichas(params = {}) {
    const response = await api.get('/reportes/fichas', { params })
    return response.data
  },

  async getEstadisticas(params = {}) {
    const response = await api.get('/reportes/estadisticas', { params })
    return response.data
  },

  async getTendencias(params = {}) {
    const response = await api.get('/reportes/tendencias', { params })
    return response.data
  },
}

